import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictExpenseTypes } from '../../queries/getDataForDropdowns'
import { isEmpty } from 'lodash'
// props here holds the classes and pass it down
const namePlaceholder = props => (
  <Query query={dictExpenseTypes} variables={{ subType: props.subType }} errorPolicy="all">
    {({ loading, error, data }) => {
      // console.log(data)
      if (error) return `<p>${error}</p>`
      if (loading) {
        return <p>Loading...</p>
      } else {
        const { helperText = 'Type ...', labelText = '', ...rest } = props
        //if (isEmpty(data.expenseTypes)) return `<p>Missing expenseTypes document</p>`
        //console.log(data.expenseTypes)
        return (
          <AutoCompleteDropdown
            options={
              isEmpty(data.expenseTypes)
                ? []
                : data.expenseTypes.map(d => ({
                  value: d.id,
                  label: d.name
                }))
            }
            placeholder={helperText}
            labelText={labelText}
            {...rest}
          />
        )
      }
    }}
  </Query>
)

export default graphql(dictExpenseTypes)(namePlaceholder)
